/* Solerza keuzehulp-analytics v1 – gedeelde, anonieme meetlaag voor alle keuzehulpen (algemeen, plissé, jaloezieën,
   rolgordijnen, horren). Wordt om de keuzehulpen heen gebouwd: de modules geven alleen hun huidige stap en antwoorden door
   via SolerzaAdvisorAnalytics.emit(); hun beslislogica en UI blijven ongewijzigd.
   - Geen persoonsgegevens: alleen keuzehulp-antwoorden (raamtype, behoefte, boren, …), sessie-id van de keuzehulp en adviescategorie.
   - Alleen versturen met toestemming voor analytics (Shopify Customer Privacy API). Zonder toestemming wordt niets verstuurd.
   - Versturen asynchroon in batches naar de app proxy (/apps/keuzehulp/events); fouten worden genegeerd, de keuzehulp werkt altijd door.
   - dataLayer (GTM/GA4, 06-10-2026): deze laag pusht daarnaast de uniforme stap-/antwoord-events naar window.dataLayer,
     onafhankelijk van de backend: advisor_started, advisor_step_view, advisor_answer, advisor_back, advisor_result,
     advisor_help_click, advisor_window_added, advisor_restart. advisor_open, advisor_abandon en de CTA-events
     (advisor_best_click / advisor_alternative_click) pusht elke module zelf (bestaande events) – hier dus niet, zodat
     één actie nooit twee events geeft. Alleen stabiele codes, geen teksten of persoonsgegevens. */
(function () {
  'use strict';
  if (window.SolerzaAdvisorAnalytics) return;
  var script = document.currentScript;
  var ENDPOINT = (script && script.getAttribute('data-endpoint')) || '/apps/keuzehulp/events';
  var DEBUG = /(^|[?&#])kh_analytics_debug\b/.test(location.search + location.hash) || window.KH_ANALYTICS_DEBUG === true;
  var STORE = 'solerza_advisor_analytics_v1';
  var HANDOFF = 'solerza_advisor_handoff_v1';
  var NON_QUESTION = { intro: 1, loading: 1, result: 1, escape: 1, resume: 1 };
  var TYPES = { general: 1, plisse: 1, jaloezie: 1, rolgordijn: 1, horren: 1 };

  // ---------- Vertaling van module-antwoorden naar uniforme velden ----------
  var NEED = {
    general: { donker: 'zo_donker_mogelijk', privacy: 'privacy_daglicht', regelen: 'licht_zelf_regelen', insecten: 'insecten_buiten' },
    plisse: { donker: 'zo_donker_mogelijk', privacy: 'privacy_daglicht', isolatie: 'isolatie', zon: 'zon_warmte_weren', vocht: 'vochtbestendig' },
    rolgordijn: { donker: 'zo_donker_mogelijk', licht: 'privacy_daglicht', spelen: 'licht_zelf_regelen' }
  };
  var WINDOW = { draaikiep: 'draaikiep', standaard: 'vast_standaard', vast: 'vast_standaard', deur: 'deur', enkeldeur: 'deur', dubbeldeur: 'deur', dakraam: 'dakraam', anders: 'anders' };
  var DRILL = { ja: 'ja', nee: 'nee', weetniet: 'weet_niet' };
  // ---------- dataLayer: stabiele vraag- en antwoordcodes ----------
  // Stap (view) → vraag-id per module; niet-vraagschermen hebben een eigen step_id
  var STEP = {
    general: { g1: 'need', g2: 'window_type', g3: 'drilling', g4: 'window_size' },
    plisse: { a1: 'window_type', a2: 'drilling', a3: 'frame_material', a3k: 'glazing_bars', a4: 'window_size', b1: 'needs', a5: 'glazing_bead' },
    jaloezie: { j1: 'room', j2: 'material', j3: 'window_size' },
    rolgordijn: { r1: 'room', r2: 'window_type', r3: 'need', r4: 'light_control' },
    horren: { h1: 'window_type', h2: 'window_width', h3: 'opening_direction', h4: 'screen_or_shutter', h5: 'mounting', h6: 'floor', h7: 'mesh' }
  };
  // Antwoordsleutel in de module → question_id
  var QID = {
    general: { goal: 'need', opening: 'window_type', drill: 'drilling', size: 'window_size' },
    plisse: { window: 'window_type', drill: 'drilling', frame: 'frame_material', kruis: 'glazing_bars', width: 'width_range', height: 'height_range', needs: 'needs', glaslat: 'glazing_bead' },
    jaloezie: { room: 'room', material: 'material', size: 'window_size' },
    rolgordijn: { room: 'room', window: 'window_type', wish: 'need', regel: 'light_control' },
    horren: { type: 'window_type', width: 'window_width', open: 'opening_direction', screen: 'screen_or_shutter', drill: 'mounting', floor: 'floor', mesh: 'mesh' }
  };
  var CODE = {
    window_type: { draaikiep: 'turn_tilt', standaard: 'standard', vast: 'fixed', deur: 'door', enkeldeur: 'single_door', dubbeldeur: 'double_door', dakraam: 'roof_window', anders: 'other' },
    drilling: { ja: 'drill_ok', nee: 'no_drill', weetniet: 'unknown' },
    need: { donker: 'blackout', privacy: 'privacy_daylight', regelen: 'light_control', insecten: 'insects', licht: 'light_privacy', spelen: 'light_control' },
    needs: { donker: 'blackout', privacy: 'privacy_daylight', isolatie: 'insulation', zon: 'sun_heat', vocht: 'moisture' },
    window_size: { groot: 'too_large_no_drill', binnen: 'within_no_drill_limits', weetniet: 'unknown' },
    light_control: { ja: 'yes', nee: 'no' },
    room: { woonkamer: 'living_room', keuken: 'kitchen', slaapkamer: 'bedroom', kantoor: 'office', badkamer: 'bathroom', kinderkamer: 'kids_room', anders: 'other' },
    frame_material: { kunststof: 'pvc', aluminium: 'aluminium', hout: 'wood', onbekend: 'unknown' },
    glazing_bars: { ja: 'yes', nee: 'no' },
    glazing_bead: { ja: 'enough_space', nee: 'not_enough_space', weetniet: 'unknown' },
    opening_direction: { binnen: 'inward', buiten: 'outward' },
    screen_or_shutter: { ja: 'yes', nee: 'no' },
    mounting: { ja: 'no_drill', nee: 'screws' },  // horren: "Wil je de hor zonder boren monteren?"
    floor: { bg: 'ground_floor', v1: 'first_floor', v2: 'second_floor_or_higher' },
    window_width: { normaal: 'normal', breed: 'wide', twijfel: 'unsure' }
  };
  function code(qid, v) { var m = CODE[qid] || {}; var c = m[v] || String(v); return c.toLowerCase().replace(/[^a-z0-9_]+/g, '_').slice(0, 60); }
  function stepId(type, view) { return (STEP[type] || {})[view] || ({ result: 'result', escape: 'whatsapp_advice' }[view]) || String(view || '').slice(0, 30); }
  function dl(s, name, win, extra) {
    try {
      var ev = { event: name, advisor_session_id: s.sid, module: s.type, window_index: (win && win.index) || 1, window_count: (win && win.count) || s.count || 1,
        entry_point: s.entry_point || null, entry_source: s.entry_source || null };
      for (var k in extra || {}) ev[k] = extra[k];
      (window.dataLayer = window.dataLayer || []).push(ev);
      if (DEBUG) { try { console.log('[keuzehulp-dataLayer]', ev); } catch (e) {} }
    } catch (e) {}
  }
  function mapNeed(type, id) { var m = NEED[type] || {}; return m[id] || (type + ':' + id); }
  function fields(type, a) {
    a = a || {};
    var f = { needs: [], window_type: null, window_type_raw: null, drilling_allowed: null, frame_material: null };
    if (type === 'general') { if (a.goal) f.needs = [mapNeed(type, a.goal)]; f.window_type_raw = a.opening || null; f.drilling_allowed = DRILL[a.drill] || null; }
    else if (type === 'plisse') { f.needs = (Array.isArray(a.needs) ? a.needs : []).map(function (n) { return mapNeed(type, n); }); f.window_type_raw = a.window || null; f.drilling_allowed = DRILL[a.drill] || null; f.frame_material = a.frame || null; }
    else if (type === 'rolgordijn') { if (a.wish) f.needs = [mapNeed(type, a.wish)]; f.window_type_raw = a.window || null; }
    // Horren: de vraag is "Wil je de hor zonder boren monteren?" → ja betekent: niet boren
    else if (type === 'horren') { f.window_type_raw = a.type || null; f.drilling_allowed = a.drill === 'ja' ? 'nee' : a.drill === 'nee' ? 'ja' : null; }
    f.window_type = f.window_type_raw ? (WINDOW[f.window_type_raw] || 'anders') : null;
    return f;
  }
  // Adviescategorie voor de gespecialiseerde modules (algemeen geeft de categorie zelf door)
  function categoryFor(type, model) {
    if (type === 'rolgordijn') return /^d/.test(model || '') ? 'duo' : 'rolgordijn';
    return type;
  }
  var FAMILY = { plisse: 'plisse', zonderboren: 'plisse', jaloezie: 'jaloezie', rolgordijn: 'rolgordijn', duo: 'rolgordijn', horren: 'horren' };
  var ROOTS = { general: '[data-general-advisor-root]', plisse: '[data-plisse-advisor-root]', jaloezie: '[data-jaloezie-advisor-root]', rolgordijn: '[data-rolgordijn-advisor-root]', horren: '[data-horren-advisor-root]' };
  var CTA_ATTR = { plisse: 'data-kh-cta', jaloezie: 'data-kj-cta', rolgordijn: 'data-kr-cta', horren: 'data-kz-cta' };

  function path(url) { try { var u = new URL(url, location.href); return (u.hostname.indexOf('wa.me') > -1 ? 'whatsapp' : u.pathname).slice(0, 200); } catch (e) { return null; } }
  function clone(o) { try { return JSON.parse(JSON.stringify(o || {})); } catch (e) { return {}; } }
  function same(a, b) { return JSON.stringify(a) === JSON.stringify(b); }
  function empty(a) { for (var k in a) { if (a[k] !== undefined && a[k] !== null && !(Array.isArray(a[k]) && !a[k].length)) return false; } return true; }

  // ---------- Opslag in de sessie (technische meetstatus + laatst gemeten antwoordcodes, zodat herladen geen dubbele events
  //            geeft; geen persoonsgegevens) ----------
  var mem = { seq: {}, once: {}, nav: {}, ans: {}, lv: {} };
  function load() { try { var s = JSON.parse(sessionStorage.getItem(STORE) || 'null'); if (s && s.seq && s.once) { mem = s; mem.nav = mem.nav || {}; mem.ans = mem.ans || {}; mem.lv = mem.lv || {}; } } catch (e) {} }
  function save() { try { sessionStorage.setItem(STORE, JSON.stringify(mem)); } catch (e) {} }
  load();
  function nextId(sid) { mem.seq[sid] = (mem.seq[sid] || 0) + 1; save(); return sid + ':' + mem.seq[sid]; }
  function once(key) { if (mem.once[key]) return false; mem.once[key] = 1; save(); return true; }

  // ---------- Toestemming (Shopify Customer Privacy API) ----------
  var consent = null, consentRequested = false;
  function evalConsent() {
    if (window.KH_ANALYTICS_FORCE_CONSENT === true) { consent = true; return consent; }
    try { var cp = window.Shopify && window.Shopify.customerPrivacy; if (cp && typeof cp.analyticsProcessingAllowed === 'function') consent = !!cp.analyticsProcessingAllowed(); } catch (e) {}
    return consent;
  }
  function requestConsent() {
    if (consentRequested) return; consentRequested = true;
    if (evalConsent() !== null) return onConsent();
    try {
      if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
        window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (err) { if (!err) { evalConsent(); onConsent(); } });
      }
    } catch (e) {}
  }
  document.addEventListener('visitorConsentCollected', function () { evalConsent(); onConsent(); });
  function onConsent() { if (consent === true) flush(false); else if (consent === false) queue.length = 0; }

  // ---------- Verzenden ----------
  var queue = [], timer = null, sending = false, attempts = 0;
  function enqueue(ev) {
    if (DEBUG) { try { console.log('[keuzehulp-analytics]', ev); } catch (e) {} }
    var log = window.KH_ANALYTICS_LOG = window.KH_ANALYTICS_LOG || []; if (log.length < 500) log.push(ev); // alleen voor QA in de browser
    if (consent === false) return;
    queue.push(ev); if (queue.length > 200) queue.splice(0, queue.length - 200);
    requestConsent(); schedule();
  }
  function schedule() { if (timer) return; timer = setTimeout(function () { timer = null; flush(false); }, 1500); }
  function flush(unload) {
    if (consent !== true || !queue.length || (sending && !unload)) return;
    var batch = queue.splice(0, 50);
    var body = JSON.stringify({ v: 1, events: batch });
    if (unload && navigator.sendBeacon) {
      try { if (navigator.sendBeacon(ENDPOINT, new Blob([body], { type: 'text/plain' }))) return; } catch (e) {}
    }
    sending = true;
    try {
      fetch(ENDPOINT, { method: 'POST', headers: { 'Content-Type': 'text/plain' }, body: body, keepalive: body.length < 60000, credentials: 'same-origin' })
        .then(function (r) { sending = false; if (r.status >= 500 || r.status === 429) retry(batch); else { attempts = 0; if (queue.length) schedule(); } },
              function () { sending = false; retry(batch); });
    } catch (e) { sending = false; }
  }
  // Maximaal twee nieuwe pogingen; event_id's zijn stabiel, de server negeert dubbele events
  function retry(batch) { if (++attempts > 2) { attempts = 0; return; } queue = batch.concat(queue).slice(0, 200); setTimeout(function () { flush(false); }, 3000 * attempts); }
  window.addEventListener('pagehide', function () { flush(true); });
  document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'hidden') flush(true); });

  // ---------- Sessiestatus per keuzehulp-sessie ----------
  var S = {}, active = {};
  function sess(type, sid, entry) {
    var s = S[sid];
    if (!s) {
      s = S[sid] = { type: type, sid: sid, lastView: mem.lv[sid] || {}, answers: mem.ans[sid] || {}, entry_source: null, entry_context: null, parent: null };
      s.nav = mem.nav[sid] || []; // getoonde vraagschermen in volgorde ("raam:stap"), voor step_number en advisor_back
      // Doorverwijzing vanuit de algemene keuzehulp (Bekijk oplossing) → koppel de sessies, binnen 30 minuten
      try {
        var h = JSON.parse(sessionStorage.getItem(HANDOFF) || 'null');
        if (h && type !== 'general' && FAMILY[h.dest] === type && Date.now() - h.ts < 30 * 60 * 1000) { s.parent = h.from; s.entry_source = 'general_advisor'; sessionStorage.removeItem(HANDOFF); }
      } catch (e) {}
    }
    if (entry && entry.entry_source === 'general_advisor') s.entry_source = 'general_advisor';
    if (entry && !s.entry_source) s.entry_source = entrySource(type, entry);
    s.prefilled = (entry && entry.prefilled) || [];
    if (entry && entry.entry_point && !s.entry_point) s.entry_point = String(entry.entry_point);
    if (entry) s.entry_context = type === 'general' ? 'general' : type === 'plisse' ? (entry.entry_context || 'plisse') : type;
    active[type] = sid;
    return s;
  }
  // Uniforme ingang. De bestaande entry_point-waarde van de module gaat daarnaast ongewijzigd mee als entry_point.
  function entrySource(type, entry) {
    var ep = entry.entry_point;
    if (type === 'general') return ep === 'url' ? 'direct_url' : (ep || 'menu');
    if (type === 'plisse') {
      if (entry.entry_context === 'no_drill' || ep === 'no_drill_landing') return 'zonder_boren_collection';
      if (entry.entry_context === 'easy_click') return 'easy_click_collection';
      if (ep === 'collection' || ep === 'plisse_landing') return 'plisse_collection';
    }
    if (ep === 'collection') return type + '_collection';
    return ep || 'unknown';
  }
  function build(s, name, win, extra) {
    var w = win || { index: 1, count: 1, answers: {} };
    var ev = { event_id: nextId(s.sid), event_name: name, advisor_type: s.type, advisor_session_id: s.sid, parent_session_id: s.parent,
      ts: new Date().toISOString(), entry_source: s.entry_source, entry_point: s.entry_point || null, entry_context: s.entry_context,
      window_index: w.index, window_count: w.count, step: s.lastView[w.index] || null };
    var f = fields(s.type, w.answers); for (var k in f) ev[k] = f[k];
    for (var x in extra || {}) ev[x] = extra[x];
    return ev;
  }

  // ---------- Verwerking van module-meldingen ----------
  function onView(s, p, win) {
    var view = p.view, idx = win.index, prevView = s.lastView[idx];
    // Antwoorden: elk gewijzigd antwoord apart registreren (meerkeuze behoeften als lijst)
    var prev = s.answers[idx] || {}, cur = clone(win.answers);
    // Gespecialiseerde modules: alle antwoorden leeg na eerdere antwoorden = opnieuw begonnen (de algemene meldt dit zelf)
    if (s.type !== 'general' && !empty(prev) && empty(cur)) { enqueue(build(s, 'advisor_restart', win, {})); dl(s, 'advisor_restart', win, {}); s.nav = []; }
    var navIdx = s.nav.lastIndexOf(idx + ':' + prevView), stepNo = navIdx < 0 ? null : stepNumber(s, idx, navIdx);
    for (var key in cur) {
      if (cur[key] === undefined || cur[key] === null || (Array.isArray(cur[key]) && !cur[key].length) || same(cur[key], prev[key])) continue;
      var v = cur[key]; var isNeeds = Array.isArray(v);
      enqueue(build(s, 'advisor_answer', win, { step: prevView || null, question: key, answer_value: isNeeds ? v.join(',').slice(0, 200) : String(v).slice(0, 80) }));
      // dataLayer: niet voor antwoorden die uit de algemene keuzehulp zijn doorgegeven (die zijn daar al gemeten)
      if (s.prefilled.indexOf(key) < 0) {
        var qid = (QID[s.type] || {})[key] || key;
        dl(s, 'advisor_answer', win, { question_id: qid, answer_code: isNeeds ? v.map(function (x) { return code(qid, x); }).join(',') : code(qid, v), step_id: stepId(s.type, prevView), step_number: stepNo });
      }
    }
    s.answers[idx] = cur; mem.ans[s.sid] = s.answers;
    if (!NON_QUESTION[view]) {
      if (once(s.sid + ':started')) { enqueue(build(s, 'advisor_started', win, { step: view })); dl(s, 'advisor_started', win, { step_id: stepId(s.type, view) }); }
      if (prevView !== view) {
        s.lastView[idx] = view; enqueue(build(s, 'advisor_step_view', win, { step: view }));
        var key2 = idx + ':' + view, at = s.nav.lastIndexOf(key2);
        if (at > -1) { // terug naar een eerder getoonde vraag (Vorige vraag, of vanaf het advies)
          s.nav = s.nav.slice(0, at + 1);
          dl(s, 'advisor_back', win, { from_step_id: stepId(s.type, prevView), step_id: stepId(s.type, view), step_number: stepNumber(s, idx, at) });
        } else s.nav.push(key2);
        at = s.nav.lastIndexOf(key2);
        dl(s, 'advisor_step_view', win, { step_id: stepId(s.type, view), step_number: stepNumber(s, idx, at) });
      }
    } else if (view !== 'resume') s.lastView[idx] = view;
    mem.nav[s.sid] = s.nav; mem.lv[s.sid] = s.lastView; save();
    if (view === 'result' || view === 'escape') results(s, p, win);
  }
  function stepNumber(s, idx, at) { var n = 0; for (var i = 0; i <= at && i < s.nav.length; i++) if (s.nav[i].split(':')[0] == idx) n++; return n || null; }
  function results(s, p, win) {
    if (s.type === 'general') {
      (p.results || []).forEach(function (r) {
        var w = { index: r.window_index, count: win.count, answers: r.answers };
        if (once(s.sid + ':result:' + r.window_index + ':' + JSON.stringify(r.answers))) {
          enqueue(build(s, 'advisor_result', w, { step: 'result', recommended_category: r.dest, recommended_route: r.route || null }));
          dl(s, 'advisor_result', w, { result_code: r.dest, result_route: r.route || null });
        }
      });
      return;
    }
    var root = document.querySelector(ROOTS[s.type]); var a = root && root.querySelector('[' + CTA_ATTR[s.type] + '="best"]');
    var extra = a ? { recommended_category: categoryFor(s.type, a.getAttribute('data-model')), recommended_model: (a.getAttribute('data-model') || '').slice(0, 60), recommended_route: path(a.getAttribute('href')) }
                  : { recommended_category: 'whatsapp', recommended_route: 'whatsapp', recommended_model: null };
    extra.step = p.view;
    if (once(s.sid + ':result:' + JSON.stringify(win.answers))) {
      enqueue(build(s, 'advisor_result', win, extra));
      dl(s, 'advisor_result', win, { result_code: extra.recommended_model || 'whatsapp', result_category: extra.recommended_category, result_route: extra.recommended_route || null });
    }
  }
  function onLegacy(s, p, win) {
    var n = p.name, q = p.params || {};
    if (n === 'advisor_open') enqueue(build(s, 'advisor_open', win, { resumed: !!q.resumed }));
    else if (n === 'advisor_abandon') enqueue(build(s, 'advisor_abandon', win, { step: q.last_step || null }));
    else if (n === 'advisor_best_click' || n === 'advisor_alternative_click') {
      var cat = s.type === 'general' ? q.category : categoryFor(s.type, q.model);
      var w = win; if (s.type === 'general' && q.advisor_window_index) w = { index: q.advisor_window_index, count: win.count, answers: (p.windows && p.windows[q.advisor_window_index - 1]) || win.answers };
      enqueue(build(s, 'advisor_cta_click', w, { cta_rank: n === 'advisor_best_click' ? 'best' : 'alternative', recommended_category: cat || null, recommended_model: q.model ? String(q.model).slice(0, 60) : null, recommended_route: path(q.url) }));
      if (s.type === 'general' && q.category) { try { sessionStorage.setItem(HANDOFF, JSON.stringify({ from: s.sid, dest: q.category, ts: Date.now() })); } catch (e) {} }
      flush(true);
    }
  }

  // Publieke API voor de modules. Fouten blijven altijd binnen deze laag.
  function emit(type, kind, p) {
    try {
      if (!TYPES[type] || !p || !p.sid) return;
      var s = sess(type, String(p.sid).slice(0, 64), p.entry);
      var pe = p.entry || {}; var win = { index: p.window_index || +pe.window_index || 1, count: p.window_count || +pe.window_count || 1, answers: p.answers || {} }; // specialist in een ruimte: raamnummer uit de doorgifte s.count = win.count;
      if (kind === 'view') onView(s, p, win);
      else if (kind === 'legacy') onLegacy(s, p, win);
      else if (kind === 'window_added') { enqueue(build(s, 'advisor_window_added', win, {})); dl(s, 'advisor_window_added', win, {}); }
      else if (kind === 'restart') { enqueue(build(s, 'advisor_restart', win, {})); dl(s, 'advisor_restart', win, {}); s.nav = []; mem.nav[s.sid] = []; save(); }
    } catch (e) { if (DEBUG) try { console.warn('[keuzehulp-analytics]', e); } catch (x) {} }
  }

  // WhatsApp-hulp: één klik-listener per keuzehulp-container (geen document-brede listener)
  function bindHelp() {
    Object.keys(ROOTS).forEach(function (type) {
      var root = document.querySelector(ROOTS[type]); if (!root || root.__khHelp) return; root.__khHelp = true;
      root.addEventListener('click', function (e) {
        try {
          var a = e.target.closest && e.target.closest('a[href*="wa.me/"]'); if (!a) return;
          var sid = active[type]; var s = sid && S[sid]; if (!s) return;
          var idx = +(a.getAttribute('data-kg-win') || 0) || 1;
          enqueue(build(s, 'advisor_help_click', { index: idx, count: s.count || 1, answers: s.answers[idx] || {} }, { help_channel: 'whatsapp' }));
          dl(s, 'advisor_help_click', { index: idx, count: s.count || 1 }, { cta: 'whatsapp', destination: 'whatsapp', step_id: stepId(s.type, s.lastView[idx]) });
          flush(true);
        } catch (x) {}
      }, true);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bindHelp); else bindHelp();

  window.SolerzaAdvisorAnalytics = { emit: emit, flush: function () { flush(false); }, version: 1 };
})();
